var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportGenModule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 66,
    viewBox: "0 0 63 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5379_7289",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 63,
    height: 66
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 7.45263C3 6.27172 3.46912 5.13918 4.30415 4.30415C5.13918 3.46912 6.27172 3 7.45263 3H43.0737C44.2546 3 45.3871 3.46912 46.2222 4.30415C47.0572 5.13918 47.5263 6.27172 47.5263 7.45263V62.3684H7.45263C6.27172 62.3684 5.13918 61.8993 4.30415 61.0643C3.46912 60.2292 3 59.0967 3 57.9158V7.45263Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 5.93684,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5264 32.6842C47.5264 31.897 47.8391 31.1419 48.3958 30.5853C48.9525 30.0286 49.7075 29.7158 50.4948 29.7158H56.4316C57.2189 29.7158 57.9739 30.0286 58.5306 30.5853C59.0873 31.1419 59.4001 31.897 59.4001 32.6842V57.9158C59.4001 59.0967 58.9309 60.2293 58.0959 61.0643C57.2609 61.8993 56.1283 62.3685 54.9474 62.3685H47.5264V32.6842Z",
    stroke: "white",
    strokeWidth: 5.93684,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9053 14.8735H23.779M11.9053 25.263H29.7158",
    stroke: "black",
    strokeWidth: 5.93684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5379_7289)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4.4209 -2.93701H66.8212V68.3051H-4.4209V-2.93701Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportGenModule);
export default __webpack_public_path__ + "static/media/reportGenModule.ae356ca33782d6851d92cbe03bc1cd64.svg";
export { ForwardRef as ReactComponent };